import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20minimalist%20product%20display%20background%20with%20soft%20warm%20terracotta%20and%20cream%20gradient%2C%20geometric%20shapes%2C%20circular%20accents%2C%20modern%20editorial%20style%2C%20light%20airy%20atmosphere%2C%20professional%20photography%20backdrop%2C%20no%20text%2C%20subtle%20texture%2C%20elegant%20artistic%20design&width=1800&height=1000&seq=hero-main-v4&orientation=landscape"
        alt="AcBuy Spreadsheet background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/18 to-black/28"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6 animate-fade-in-up">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-background-50">Updated Daily &bull; 10,000+ Products</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-5 animate-fade-in-up animation-delay-100">
          Best AcBuy Spreadsheet <span className="text-accent-400">2026</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up animation-delay-200">
          Discover verified AcBuy spreadsheets, trusted sellers, product links, and expert buying guides. Everything you need to shop smarter in one organized place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-300">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm whitespace-nowrap transition-all cursor-pointer"
          >
            Browse Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50/20 backdrop-blur-sm hover:bg-background-50/30 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm border border-background-50/30 whitespace-nowrap transition-all cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-3-line"></i>
          </a>
          <Link
            to="/acbuy-spreadsheet-guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-background-50/80 hover:text-background-50 font-medium px-6 py-3.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer"
          >
            Read Guide
            <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-6 text-background-50/70 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-400"></i>
            <span>Verified Sellers</span>
          </div>
          <div className="w-px h-3 bg-background-50/30"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-accent-400"></i>
            <span>Updated Daily</span>
          </div>
          <div className="w-px h-3 bg-background-50/30"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-star-line text-accent-400"></i>
            <span>Trusted by Thousands</span>
          </div>
        </div>
      </div>
    </section>
  );
}